// CL-6 — when a project has more than one open estimate (or change order), the tick asks which.
import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import '@/styles/estimate-target.css';

const stop = (e) => e.stopPropagation();

export default function EstimateTargetSheet({ targets, initialId, onPick, onClose }) {
  const start = targets.find((t) => t.id === initialId) || targets.find((t) => t.is_default) || targets[0];
  const [chosen, setChosen] = useState(start && start.id);
  return createPortal(
    <div className="kes-veil bg-black/40" onClick={onClose} data-testid="kes-veil">
      <div className="kes" onClick={stop} role="dialog" aria-label="Put it on" data-testid="kes-sheet">
        <span className="kes-k">Put it on</span>
        {targets.map((t) => (
          <button type="button" key={t.id} className={`kes-row${t.id === chosen ? ' is-on' : ''}`} onClick={() => setChosen(t.id)} data-testid={`kes-row-${t.id}`}>
            <b>{t.name}</b>
            <span className="kes-m">{t.kind === 'estimate' ? `estimate · ${t.status}` : 'change order'}{t.is_default ? (t.default_reason === 'additions' ? ' · additions' : ' · newest') : ''}</span>
          </button>
        ))}
        <div className="kes-acts">
          <button type="button" className="kes-btn kes-key" onClick={() => onPick(targets.find((t) => t.id === chosen))} data-testid="kes-pick">Add it there</button>
          <button type="button" className="kes-btn" onClick={onClose} data-testid="kes-cancel">Cancel</button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
